import { useEffect, useState } from 'react';

export const useGetUtmParams = () => {
    const [utmGetParams, setGetUtmParams] = useState<Record<string, any>>({});

    useEffect(() => {
        const stored = localStorage.getItem('utmParams');
        const parsed = stored ? JSON.parse(stored) : {};
        setGetUtmParams(parsed);

        const handleStorageChange = () => {
            const updated = localStorage.getItem('utmParams');
            setGetUtmParams(updated ? JSON.parse(updated) : {});
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    return utmGetParams;
};
